<template>
  <v-card>
    <v-card-title>Оценка выступления</v-card-title>
    <template v-for="c in Criterion">
      <v-subheader class="ml-2" :key="'criterion-' + c.type">{{ c.name }}</v-subheader>
      <template v-for="item in c.items">
        <v-list-item class="ml-2" :key="'criterion-item-' + item.type">
          <v-list-item-title>{{ item.name }}</v-list-item-title>
          <v-rating
            v-model="item.rate"
            :length="10"
            color="#1f51a4"
            background-color="grey lighten-1"
          ></v-rating>
        </v-list-item>
        <v-card-text :key="'criterion-item-desc' + item.type">
          {{ item.description }}
        </v-card-text>
      </template>
    </template>
    <v-subheader class="ml-2">Комментарий</v-subheader>
    <v-textarea v-model="Comment" solo class="ml-4 mr-4"></v-textarea>
    <v-card-actions>
      <v-spacer>
      </v-spacer>
      <v-btn large @click="$emit('rate', { Comment, Criterion })">
        Отправить
      </v-btn>
      <v-spacer>
      </v-spacer>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: 'Rating',
  data () {
    return {
      Comment: '',
      Criterion: [
        {
          type: 'NonVerbalRate',
          name: 'Невербалика',
          items: [
            {
              type: 'pose',
              rate: undefined,
              name: 'Поза',
              description: 'Выступающий не был скован, но и при этом излишне расслаблен, уверенно держался, не отстранялся от слушателя.'
            },
            {
              type: 'bodyLanguage',
              rate: undefined,
              name: 'Жестикуляция',
              description: 'Жестикуляция – функциональная, руки двигаются в такт речи, помогают описывать предмет речи. Не было излишней моторики.'
            },
            {
              type: 'posture',
              rate: undefined,
              name: 'Осанка',
              description: 'Осанка - воспринимается как признак уверенного человека и позволяет правильно звучать голосу.'
            },
            {
              type: 'eyeContact',
              rate: undefined,
              name: 'Зрительный контакт',
              description: 'Выступающий не бегает глазами в поисках подсказок, а сосредоточен на Вас, на зрителе.'
            }
          ]
        },
        {
          type: 'SpeechRate',
          name: 'Речь',
          items: [
            {
              type: 'richContent',
              rate: undefined,
              name: 'Содержательность речи',
              description: 'Количество выраженных в ней мыслей, чувств и стремлений, их значительность и соответствие действительности.'
            },
            {
              type: 'comprehensibility',
              rate: undefined,
              name: 'Понятность речи',
              description: 'Синтаксически правильное построение предложений, а также применение в ' +
                'соответствующих местах пауз или выделения слов с помощью логического ударения.'
            },
            {
              type: 'expressiveness',
              rate: undefined,
              name: 'Выразительность речи',
              description: 'Эмоциональная насыщенность, богатство языковых средств, их разнообразие. По своей выразительности она может быть яркой, энергичной и, наоборот, слабой.'
            },
            {
              type: 'effectiveness',
              rate: undefined,
              name: 'Действенность речи',
              description: 'Свойство речи, заключающееся в её влиянии на мысли, чувства и волю других людей, на их убеждения и поведение.'
            }
          ]
        },
        {
          type: 'SlidesRate',
          name: 'Слайды',
          items: [
            {
              type: 'uniformStyle',
              rate: undefined,
              name: 'Выдержан единый стиль презентации',
              description: 'Смешение стилей, фонов, шрифтов, сочетание фотографий с рисунками и т.п. создает впечатление «Франкенштейна», и очень тяжело для восприятия. Презентация должна быть выполнена в едином стиле, без лишних украшений, с минимальным количеством шрифтов и цветов (см. правило 3-3)'
            },
            {
              type: 'appropriateUse',
              rate: undefined,
              name: 'Уместное использование слайдов',
              description: 'У слайдов, как почти у всех элементов презентации, должна быть определенная цель.' +
                'Более того, даже у разных элементов слайдов должна быть своя цель. «Каково предназначение этого слайда/элемента?» — вот самый важный вопрос, на который нужно ответить при разработке слайдов.'
            },
            {
              type: 'focus',
              rate: undefined,
              name: 'Акценты',
              description: 'Важно зрительно отделять более важную информацию от менее важной. Пусть важные элементы будут крупными и яркими, а менее важные — маленькими и близкими по цвету к фону. Если вы захотите выделить более одной концепции — можете потерять фокус.'
            },
            {
              type: 'visualization',
              rate: undefined,
              name: 'Визуализация',
              description: 'Старайтесь визуализировать максимальное количество контента (фотографии, иконки, графики). Если текст достаточно сказать словами, то просто скажите его.'
            }
          ]
        }
      ]
    }
  }
}
</script>

<style scoped>

</style>
